"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDepositSchemeDisplayAmount = exports.getPropertyImageUrl = exports.getFeatureIconOrDefault = exports.getBrandConfig = exports.getActiveDepositScheme = exports.generatePropertyImageUrl = exports.generateNovasolPropertyImageUrl = void 0;
const brand_config_1 = require("./brand.config");
const brand_utils_1 = require("./brand.utils");
const getBrandConfig = (brand) => brand_config_1.brandConfig[brand];
exports.getBrandConfig = getBrandConfig;
const generateNovasolPropertyImageUrl = (staticAssetDomain, filename, imageSize) => {
    return `${staticAssetDomain}/pic/${imageSize}/${filename.substring(0, 3)}/${filename}`;
};
exports.generateNovasolPropertyImageUrl = generateNovasolPropertyImageUrl;
const generatePropertyImageUrl = (staticAssetDomain, assetId, size) => `${staticAssetDomain}/property/${assetId.substring(0, 3)}/${size}/${assetId}.jpg`;
exports.generatePropertyImageUrl = generatePropertyImageUrl;
const getPropertyImageUrl = ({ staticAssetDomain, assetId, filename, size, brand, }) => {
    return brand === 'novasol' || brand === 'fincallorca'
        ? generateNovasolPropertyImageUrl(staticAssetDomain, filename, size)
        : generatePropertyImageUrl(staticAssetDomain, assetId, size);
};
exports.getPropertyImageUrl = getPropertyImageUrl;
const getActiveDepositScheme = (deposits, usersCurrentDate, bookingStartDate, sleeps, bookingPrice, accommodationType) => {
    const matchedDepositScheme = deposits
        .filter(({ accommodationTypes }) => accommodationTypes.includes(accommodationType))
        .find(({ rules }) => {
        const { bookingStartDateMin, bookingStartDateMax, propertySleepsMax, propertySleepsMin, bookingLeadTimeMin, bookingPriceMin, bookingPriceMax, } = rules;
        return ((0, brand_utils_1.withinPropertySizeRange)(sleeps, propertySleepsMax) &&
            (0, brand_utils_1.overPropertyMinSize)(sleeps, propertySleepsMin) &&
            (0, brand_utils_1.overBookingPriceMin)(bookingPrice, bookingPriceMin) &&
            (0, brand_utils_1.underBookingPriceMax)(bookingPrice, bookingPriceMax) &&
            (0, brand_utils_1.bookingHasLongLeadTime)(bookingStartDate, usersCurrentDate, bookingLeadTimeMin) &&
            (0, brand_utils_1.bookingStartDateAfterRuleStart)(bookingStartDate, bookingStartDateMin) &&
            (0, brand_utils_1.bookingStartDateBeforeRuleEnd)(bookingStartDate, bookingStartDateMax));
    });
    return matchedDepositScheme || null;
};
exports.getActiveDepositScheme = getActiveDepositScheme;
/**
 * Will return a feature icon name if it exists in the Map, otherwise a default value of 'BulletPoint'
 */
const getFeatureIconOrDefault = (featureIcons, id) => {
    const name = featureIcons.get(id);
    return name || 'BulletPoint';
};
exports.getFeatureIconOrDefault = getFeatureIconOrDefault;
const getDepositSchemeDisplayAmount = (depositScheme, currencySymbol) => {
    const { amount, unitType } = depositScheme;
    if (unitType === 'price') {
        return `${currencySymbol}${amount}`;
    }
    return `${amount}%`;
};
exports.getDepositSchemeDisplayAmount = getDepositSchemeDisplayAmount;
//# sourceMappingURL=brand.js.map